"use strict";

var _require = require('../constants/post'),
    POST_CUSTOM_EXCERPT_MAX_LENGTH = _require.POST_CUSTOM_EXCERPT_MAX_LENGTH,
    POST_EXCERPT_TRUNCATED_WORD_MAX_LENGTH = _require.POST_EXCERPT_TRUNCATED_WORD_MAX_LENGTH;

var ELLIPSIS = '...';
var CONTENT_TEXT_LENGTH_WITHIN_EXCERPT = POST_CUSTOM_EXCERPT_MAX_LENGTH - ELLIPSIS.length;

function getExcerptFromContentText(contentText) {
  if (!contentText) {
    return '';
  }

  var cleanContent = contentText.replace(/ *\n */g, ' ').trim();

  if (cleanContent.length <= POST_CUSTOM_EXCERPT_MAX_LENGTH) {
    return cleanContent;
  }

  var truncated = cleanContent.substring(0, POST_CUSTOM_EXCERPT_MAX_LENGTH);
  var words = truncated.split(' ');
  var allWordsExceptLastOne = words.slice(0, -1).join(' ');
  var withoutEllipsis = allWordsExceptLastOne.length <= CONTENT_TEXT_LENGTH_WITHIN_EXCERPT ? allWordsExceptLastOne : words.slice(0, -2).join(' ');
  var leavingLongLastWord = withoutEllipsis.length < POST_CUSTOM_EXCERPT_MAX_LENGTH - POST_EXCERPT_TRUNCATED_WORD_MAX_LENGTH ? truncated.substring(0, CONTENT_TEXT_LENGTH_WITHIN_EXCERPT) : withoutEllipsis;
  return "" + leavingLongLastWord + ELLIPSIS;
}

module.exports = getExcerptFromContentText;